export default {
  boolean: ['switch'],
  object: ['fieldset'],
  array: ['checkboxes', 'list'],
  number: ['digit'],
  integer: ['digit'],
  string: ['date', 'select', 'text'],
}
